module.exports = __webpack_public_path__ + "static/media/ins-1.44947f13.webp";